import axios from './axios'
import { CreateProductDto, ProductDto, UpdateProductDto } from './types'

export const getProducts = () => {
  return axios.get<ProductDto[]>('/products')
}

export const getProduct = (id: string) => {
  return axios.get<ProductDto>(`/products/${id}`)
}

export const createProduct = (data: CreateProductDto) => {
  return axios.post<ProductDto>('/products', data)
}

export const updateProduct = (id: string, data: UpdateProductDto) => {
  return axios.put<ProductDto>(`/products/${id}`, data)
}
